import { replace } from "lodash";

export default function viewExtraLink(extraLink: string) {
  if (extraLink.startsWith("https://")) return replace(extraLink, "https://");
  return extraLink;
}
